/**
 *  缓存页签滚动条位置hook mixin
 *  只在main.js中统一注册一次, 其他页面勿用
 */
/* eslint-disable */
export default {
    beforeRouteLeave(to, from, next) {
        // 只有离开模块根页面(index.vue)时才缓存滚动条位置
        // 页签不存在或已关闭不缓存滚动条位置
        if (this.$options.options && this.$options.options.needSavedPosition && from && from.matched && from.matched[1] && from.matched[1].meta.savedPosition && this.$store.state.tagsView.cachedViews.includes(from.matched[1].name)) {
            const scrollDom = document.querySelector('.body-container'); 

            from.matched[1].meta.savedPosition.x = scrollDom.scrollLeft;
            from.matched[1].meta.savedPosition.y = scrollDom.scrollTop;
        }
        next();
    },
}
